import * as React from "react"
import Box from "@mui/material/Box"
import TabsWrappedLabel from "../../../../components/tabs/tabs-component"
import PropTypes from "prop-types"

const CompanyTabsWrappedLabel = ({
    companyTabChildren,
    marketToMarketTabChildren,
    balanceTabChildren,
    emissionTabChildren,
    economicGroupTabChildren,
    otherDocumentsTabChildren,
}) => {
    return (
        <Box
            sx={{
                width: "100%",
            }}
        >
            <TabsWrappedLabel
                tabs={[
                    {
                        value: "company",
                        label: "EMPRESA",
                        content: companyTabChildren,
                    },
                    {
                        value: "marketToMarket",
                        label: "MARKET TO MARKET",
                        content: marketToMarketTabChildren,
                    },
                    {
                        value: "balance",
                        label: "BALANÇOS",
                        content: balanceTabChildren,
                    },
                    {
                        value: "emission",
                        label: "EMISSÕES",
                        content: emissionTabChildren,
                    },
                    {
                        value: "economicGroup",
                        label: "GRUPO ECONÔMICO",
                        content: economicGroupTabChildren,
                    },
                    {
                        value: "otherDocuments",
                        label: "OUTROS DOCUMENTOS",
                        content: otherDocumentsTabChildren,
                    },
                ]}
            />
        </Box>
    )
}

CompanyTabsWrappedLabel.propTypes = {
    companyTabChildren: PropTypes.node,
    marketToMarketTabChildren: PropTypes.node,
    balanceTabChildren: PropTypes.node,
    emissionTabChildren: PropTypes.node,
    economicGroupTabChildren: PropTypes.node,
    otherDocumentsTabChildren: PropTypes.node,
}

export default CompanyTabsWrappedLabel
